export default __webpack_public_path__ + "static/media/EasterDay_00.3329a4b0.png";